export default __webpack_public_path__ + "img/cursor-owl-carousel.4d136c35.png";